import { useI18n } from '../../i18n';

/**
 * #661 (F24) — the Approve and Reject pair of a pending request: an
 * invitation, a join request, a claim, a role request.
 *
 * The caller owns the lock of the row (`busy` is `resolving.isBusy(key)` of
 * `useBusyKeys()`, #605), and the write. #552 — on a phone the pair takes its
 * own line under the text, so the text keeps the width of the card. From `sm`
 * the pair sits at the right end of the row. The accessible names stay
 * "Approve" and "Reject".
 */
/** The root class of the pair. A card that shows a status badge in place of
 *  the pair (a resolved request) uses the same class, so that the badge sits
 *  where the buttons were (#663). */
export const RESOLVE_ACTIONS_CLS = 'flex gap-2 shrink-0 w-full sm:w-auto justify-end sm:ml-auto';

export default function ResolveActions({ onResolve, busy, className = '' }: {
  onResolve: (status: 'approved' | 'rejected') => void;
  busy: boolean;
  className?: string;
}) {
  const { t } = useI18n();
  return (
    <div className={`${RESOLVE_ACTIONS_CLS} ${className}`.trim()}>
      <button type="button" onClick={() => onResolve('approved')} disabled={busy} className="btn-primary btn-sm">{t.common.approve}</button>
      <button type="button" onClick={() => onResolve('rejected')} disabled={busy} className="btn-outline-red btn-sm">{t.common.reject}</button>
    </div>
  );
}
